<template lang="html">
<el-container>
<el-header class="main-body-search">
      <el-form :inline="true" :model="filters" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="filters.roleName" placeholder="角色名称" @keyup.enter.native="getRoleMutexList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getRoleMutexList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showForm(0, false, {})">新增</el-button>
          </el-form-item>
        </el-form>
</el-header>
 <el-main class="main-body-table">
     <!--列表-->
    <el-table :data="tableGridData" style="width: 100%">
          <el-table-column  type="index"  fixed  width="60"></el-table-column>
          <el-table-column  prop="roleName" label="角色" width="100"></el-table-column>
          <el-table-column  prop="detail" label="角色描述" width="250"></el-table-column>
          <el-table-column  prop="mutexRoleNames"  label="互斥角色"  width="300"></el-table-column>
          <el-table-column  prop="appName" label="所属应用" width="150"></el-table-column>
          <el-table-column  prop="status" label="状态" width="100" :formatter="formatStatus"></el-table-column>
          <el-table-column label="操作" width="250" fixed="right">
            <template slot-scope="scope">
              <el-button size="small"  :disabled="scope.row.status==='0'" @click="showForm(1, scope.$index, scope.row)">编辑</el-button>
              <el-button type="danger" :disabled="scope.row.status==='0'" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
    </el-table>
    <!--工具条-->
    <el-pagination class="main-body-table-page" layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size" :total="page.total">
    </el-pagination>
    <!--维护界面-->
    <el-dialog v-dialogDrag  ref="rolemutexdialog" :title="formLable[formType]" :visible.sync="maintainFormVisible" :close-on-click-modal="false" width="60%">
        <el-form :model="maintainForm" label-width="80px" :rules="maintainFormRules" ref="maintainForm">
          <el-row>
            <el-col :span="13">
              <el-form-item label="所属应用" prop="appId">
                 <el-select v-model="maintainForm.appId" filterable placeholder="请选择" @change="changeAppSelect">
                   <el-option  v-for="item in appList"  :key="item.id" :label="item.appName" :value="item.id"></el-option>
                 </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="11">
                <span>提示: 选择多个互斥角色时,系统不允许配置用户同时拥有这些角色</span>
            </el-col>
          </el-row>
          <el-row  :gutter="40">
            <el-col :span="12">
                <el-card class="box-card">
                   <div slot="header" class="clearfix">
                      <span>可配置角色选择:</span>
                      <span style="font-weight:bold;">{{selectRoleName}}</span>
                   </div>
                  <div class="text item">
                      <el-table ref="roleSelection" :data="roleTableData" tooltip-effect="dark" style="width: 100%"
                          height="320"  highlight-current-row @current-change="handleChangeRoleTable">
                          <el-table-column type="index" width="50"></el-table-column>
                          <el-table-column prop="roleName" label="角色" width="120"></el-table-column>
                          <el-table-column prop="detail" label="描述" width="210"></el-table-column>
                      </el-table>
                  </div>
                </el-card>
            </el-col>
            <el-col :span="12">
               <el-card class="box-card">
                   <div slot="header" class="clearfix">
                      <span>互斥角色</span>
                   </div>
                  <div class="text item">
                    <el-table ref="mutexRoleRef" :data="mutexRoleTableData" tooltip-effect="dark" style="width: 100%"
                        height="320"  @selection-change="handleMutexRoleSelectionChange">
                        <el-table-column type="selection" width="55" :selectable="selectMutexTableFunc"></el-table-column>
                        <el-table-column prop="roleName" label="角色" width="120"></el-table-column>
                        <el-table-column prop="detail" label="描述" width="210"></el-table-column>
                    </el-table>
                  </div>
                </el-card>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="maintainFormVisible = false">取消</el-button>
          <el-button type="primary" v-if="formType === 0" @click="saveMutexRole" :loading="formLoading">保存</el-button>
          <el-button type="primary" v-else @click="updateMutexRole" :loading="formLoading">保存</el-button>
        </div>
      </el-dialog>
   </el-main>
</el-container>
</template>

<script>
export default {
  data() {
    return {
      appList: [], // 应用列表
      roleSelectList: [], // 角色列表
      selectGridItemId: '', // 修改或者删除的互斥关系表主键id
      selectRoleId: '', // 选择角色id
      selectRoleName: '', // 选择角色的名称
      mutexRoleSelection: [], // 选择互斥角色
      roleTableData: [],
      mutexRoleTableData: [],
      filters: {
        appId: '',
        roleName: ''
      },
      page: {
        current: 1, // 当前页
        size: 10, // 每页个数
        total: 0 // 默认数据总数
      },
      maintainForm: {},
      maintainFormRules: {
        appId: [{ required: true, message: '请选择所属应用', trigger: 'blur' }]
      },
      formLoading: false,
      maintainFormVisible: false,
      formType: 0, // 0 add, 1, update
      formLable: ['新增', '修改'],
      tableGridData: []
    }
  },
  mounted() {
    this.initAppSelectList()
    this.getRoleMutexList()
  },
  methods: {
    initAppSelectList() {
      this.$http
        .post('/sum/sumApp/selectList')
        .then(res => {
          let { code, data } = res
          if (code === 20000) {
            this.appList = data
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    changeAppSelect(selVal) {
      // this.initRoleTableData(selVal)
      this.initMutexRoleTableData(selVal)
    },
    initMutexRoleTableData(selVal) {
      let param = { appId: this.maintainForm.appId }
      this.$http
        .post('/sum/sumRole/selectList', param)
        .then(res => {
          let { code, data } = res
          if (code === 20000) {
            this.mutexRoleTableData = data
            this.roleTableData = data
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    initRoleTableData(selVal) {
      let param = { appId: this.maintainForm.appId }
      // 获取可配置角色列表
      this.$http
        .post('/sum/sumRoleMutex/selectList', param)
        .then(res => {
          if (res.code === 20000) {
            this.roleTableData = res.data
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    handleChangeRoleTable(val) {
      if (val) {
        this.selectRoleName = val.roleName
        this.selectRoleId = val.id
      }
    },
    handleMutexRoleSelectionChange(val) {
      this.mutexRoleSelection = val
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1
    },
    // 翻页
    handleCurrentChange(val) {
      this.page.current = val
      this.getRoleMutexList()
    },
    // 查询角色互斥信息
    getRoleMutexList() {
      this.filters.current = this.page.current
      this.filters.size = this.page.size
      // 获取互斥角色列表
      this.$http
        .post('/sum/sumRoleMutex/selectPage', this.filters)
        .then(res => {
          if (res.code === 20000) {
            this.tableGridData = res.data.records
            this.page.total = res.data.total
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    // 状态显示转换
    formatStatus: function(row, column) {
      return row.status === '1' ? '已审核' : row.status === '0' ? '审核中' : '未知'
    },
    // 显示表单
    showForm(type, index, row) {
      this.maintainFormVisible = true
      this.$nextTick(() => {
        this.$refs.maintainForm.clearValidate()
      })
      this.formType = type
      if (type === 1) {
        this.selectGridItemId = row.id
        // 把选择行的数据赋值到表单
        this.maintainForm = Object.assign({}, row)
        // 初始化互斥角色列表
        this.initMutexRoleTableData(this.maintainForm.appId)
        setTimeout(() => {
          // 设置互斥角色选中状态
          let mutexRoleIdArray = row.mutexIds.split(',')
          let length = this.mutexRoleTableData.length
          for (let i = 0; i < length; i++) {
            let roleItem = this.mutexRoleTableData[i]
            if (mutexRoleIdArray.indexOf(roleItem.id) > -1) {
              this.$refs.mutexRoleRef.toggleRowSelection(roleItem)
            }
          }
          // 设置编辑的角色
          this.selectRoleId = row.roleId
          let configRole = {
            roleName: row.roleName,
            detail: row.detail,
            id: row.roleId
          }
          this.roleTableData = []
          this.roleTableData.push(configRole)
          this.$refs.roleSelection.setCurrentRow(configRole)
        }, 600)
      }
    },
    // 增加互斥角色关系
    saveMutexRole() {
      let length = this.mutexRoleSelection.length
      let selectMutexRoleArray = []
      for (let i = 0; i < length; i++) {
        let selectMutexRole = this.mutexRoleSelection[i]
        selectMutexRoleArray.push(selectMutexRole.id)
      }
      let param = {
        mutexIds: selectMutexRoleArray.join(','),
        roleId: this.selectRoleId,
        action: 1
      }
      // 新增互斥角色,添加到审核列表
      this.$http
        .post('/sum/sumRoleMutexAprv/insert', param)
        .then(res => {
          if (res.code === 20000) {
            this.maintainFormVisible = false
            this.$message({
              message: '提交审核成功',
              type: 'success'
            })
            this.getRoleMutexList()
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    // 更新互斥角色关系
    updateMutexRole() {
      let length = this.mutexRoleSelection.length
      let selectMutexRoleArray = []
      for (let i = 0; i < length; i++) {
        let selectMutexRole = this.mutexRoleSelection[i]
        selectMutexRoleArray.push(selectMutexRole.id)
      }
      let param = {
        mutexIds: selectMutexRoleArray.join(','),
        roleId: this.selectRoleId,
        action: 3,
        id: this.maintainForm.id
      }
      // 修改互斥角色,添加到审核列表
      this.$http
        .post('/sum/sumRoleMutexAprv/insert', param)
        .then(res => {
          if (res.code === 20000) {
            this.maintainFormVisible = false
            this.$message({
              message: '提交审核成功',
              type: 'success'
            })
            this.getRoleMutexList()
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    // 删除
    handleDel(index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          // 删除互斥角色,添加到审核列表
          let param = {
            mutexIds: row.mutexIds,
            roleId: row.roleId,
            action: 2,
            id: row.id
          }
          this.$http
            .post('/sum/sumRoleMutexAprv/insert', param)
            .then(res => {
              if (res.code === 20000) {
                this.maintainFormVisible = false
                this.$message({
                  message: '提交审核成功',
                  type: 'success'
                })
                this.getRoleMutexList()
              }
            })
            .catch(rej => {
              console.log(rej)
            })
        })
        .catch(() => {})
    },
    selectMutexTableFunc(row, index) {
      if (this.selectRoleName === row.roleName) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="css">
</style>
